module.exports = __webpack_public_path__ + "static/Gibson-Light-webfont-c9b3300e89a6dae925b9f1e63dd7929f.svg";